/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Foot_Pedal_SetupInputs */



/**
* | output |
* | --- |
* | "Foot Pedal Setup" |
*
* @param {Foot_Pedal_SetupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const foot_pedal_setup = /** @type {((inputs?: Foot_Pedal_SetupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Foot_Pedal_SetupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration de la pédale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fußpedal-Setup")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazione del pedale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка ножной педали")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración del pedal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("脚踏板设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フットペダルのセットアップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फुट पेडल सेटअप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configuração do pedal")
	return /** @type {LocalizedString} */ ("Foot Pedal Setup")
});